import fetchIntercept from "fetch-intercept";
import {logger} from '../logging/logger';

const log = logger('http-interceptor')

function register() {
  return fetchIntercept.register({
    request: function(url, config) {
      // Modify the url or config here
      log.debug({ interceptor: 'request', url: url, config: config, requestId: config.headers.get('X-RequestId') });
      return [url, config];
    },

    requestError: function(error) {
      // Called when an error occured during another 'request' interceptor call
      log.debug({ interceptor: 'requestError', error: error});
      return Promise.reject(error);
    },

    response: function(response) {
      // Modify the reponse object
      log.debug({ interceptor: 'response', response: response });
      return response;
    },

    responseError: function(error) {
      // Handle an fetch error
      log.debug({ interceptor: 'responseError', error: error});
      return Promise.reject(error);
    }
  });
}

export const httpClientInterceptors = {
  register
};